import { TextField } from "@mui/material";

interface FacilityRuleFieldsProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Field component for facility-based rules (Allow Facility, Deny Facility, etc.)
 */
export function FacilityRuleFields({ value, onChange }: FacilityRuleFieldsProps) {
  return (
    <TextField
      fullWidth
      label="Facility UUID"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Enter UUID"
      helperText="Enter the facility UUID"
    />
  );
}
